import { formatInspectionOperator } from '#/modules/imsMgmt/settings/inspectionKind/helper/constants';

export function formatInspectionCriteria(criteria, dataType) {
  if (!criteria || typeof criteria !== 'object') {
    return '—';
  }

  const operator = formatInspectionOperator(criteria.operator);
  if (dataType === 'DECIMAL' && criteria.operator === 'BETWEEN') {
    const left = criteria.minInclusive ? '含' : '不含';
    const right = criteria.maxInclusive ? '含' : '不含';
    return `${operator} ${criteria.min}（${left}）～ ${criteria.max}（${right}），小數 ${criteria.scale} 位`;
  }
  if (dataType === 'DECIMAL') {
    return `${operator} ${criteria.expectedValue}，小數 ${criteria.scale} 位`;
  }
  if (dataType === 'BOOLEAN') {
    const value = criteria.expectedValue === true ? '是' : '否';
    return `${operator} ${value}`;
  }
  if (dataType === 'SINGLE_SELECT') {
    const passing = (criteria.passingValues ?? []).join('、');
    return `合格：${passing || '—'}`;
  }
  if (dataType === 'JUDGMENT') {
    return '直接判定';
  }
  if (dataType === 'TEXT' && criteria.operator === 'EXACT_EQUALS') {
    return `${operator} ${criteria.expectedValue}`;
  }
  return operator;
}
